export default "__VITE_ASSET__BsqQwGYN__"